import React from 'react';
import BaseTableNew from 'components/atoms/base-table/new';
import { useConsumableLog } from 'infrastructure/hooks/logs/use-consumable-log';

import { consumableLogColumns } from './cols';

interface IPatientConsumableLogProps {
  patientGuid: string;
  dateRange?: [Date, Date];
}

const PatientConsumableLog: React.FC<IPatientConsumableLogProps> = (props) => {
  const { patientGuid, dateRange } = props;

  const { loading, items, meta, setMeta } = useConsumableLog({
    patientGuid,
    meta: {
      dateRange,
    },
  });

  const onChangePage = (page: number) => {
    setMeta({
      ...meta,
      page,
    });
  };

  return (
    <BaseTableNew
      rowKey="key"
      dataCy="consumable-log-table"
      columns={consumableLogColumns()}
      items={items}
      loading={loading}
      pagination={{
        current: meta.page,
        pageSize: meta.items,
        total: meta.totalCount,
        position: ['bottomRight'],
      }}
      onChangePage={onChangePage}
      bordered
    />
  );
};

export default PatientConsumableLog;
